'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

var _basketHelpers = require('../../../../helpers/basketHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PricePer(props) {
  var getTotalValue = function getTotalValue(ptc) {
    return ptc.priceData.totalPrice + ptc.priceData.markupAmount + ptc.priceData.feeAmount + ptc.priceData.obFeeAmount || 0;
  };

  var components = props.components,
      ptcs = props.ptcs,
      selectedCurrencyFormat = props.selectedCurrencyFormat,
      t = props.t;


  var styleTicketPricePerPtcLabel = {
    color: components.TicketPricePerPtcLabel.color,
    fontSize: components.TicketPricePerPtcLabel.fontSize,
    fontWeight: components.TicketPricePerPtcLabel.fontWeight,
    fontStyle: components.TicketPricePerPtcLabel.fontStyle,
    textDecoration: components.TicketPricePerPtcLabel.textDecoration,
    fontFamily: components.TicketPricePerPtcLabel.fontFamily
  };

  var styleTicketPricePerPtcValue = {
    color: components.TicketPricePerPtcValue.color,
    fontSize: components.TicketPricePerPtcValue.fontSize,
    fontWeight: components.TicketPricePerPtcValue.fontWeight,
    fontStyle: components.TicketPricePerPtcValue.fontStyle,
    textDecoration: components.TicketPricePerPtcValue.textDecoration,
    fontFamily: components.TicketPricePerPtcValue.fontFamily
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'PricePer' },
    _react2.default.createElement(
      'tbody',
      null,
      ptcs.map(function (ptc, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: { padding: '0' } },
            _react2.default.createElement(
              'span',
              { style: styleTicketPricePerPtcLabel },
              t('air.pricePer'),
              ' ',
              ptc.ptcCodeText,
              ':'
            ),
            _react2.default.createElement(
              'span',
              { style: styleTicketPricePerPtcValue },
              ' ',
              (0, _priceString2.default)(selectedCurrencyFormat, getTotalValue(ptc), ptc.priceData.currency),
              ' ',
              (0, _basketHelpers.getTaxDisplay)(ptc, t('air.tax'), selectedCurrencyFormat)
            )
          )
        );
      })
    )
  );
}

var mstp = function mstp(state) {
  var basketCurrencyFormat = state.rendering.shopOptions.currencyFormat;
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    selectedCurrencyFormat: basketCurrencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(PricePer));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/PricePer.jsx
// module id = 651
// module chunks = 0